/* @flow */
import * as React from 'react';

import AdminSchoolTableBodyContainer from 'admin/containers/AdminSchoolTableBodyContainer';
import SmartTable from 'components/SmartTable';
import View from 'components/View';
import CurrentUser from 'auth/CurrentUser';

// this `paid` status is true if
// the district org is paid, or a school of the district is paid.
type Props = {
  loading: boolean,
  orgId: number,
};

const nameSorts = [
  { key: 'name_asc', name: 'Ascending' },
  { key: 'name_desc', name: 'Descending' },
];

const COLUMNS = [
  { key: 'name', name: 'School', sorts: nameSorts },
  { key: 'teacher_count', name: 'Teachers' },
  { key: 'participant_count', name: 'Students and Parents' },
  { key: 'class_count', name: 'Classes' },
  { key: 'plan', name: 'Plan' },
];

function AdminSchools(props: Props) {
  const { orgId } = props;
  const namespace = `admin-school-table-${orgId}`;

  return (
    <View scroll>
      <SmartTable
        namespace={namespace}
        columns={COLUMNS}
        initialSort="name_asc"
        withSearch={
          !!CurrentUser.getUser() &&
          CurrentUser.getUser().hasFeature('do_not_add_parent_org_admins_to_children')
        }
        searchPlaceholder="Search for a school">
        {({ query, sort }) => (
          <AdminSchoolTableBodyContainer districtId={orgId} sort={sort} query={query} inGroupView />
        )}
      </SmartTable>
    </View>
  );
}

export default AdminSchools;
